<template>
  <fieldset
    class="material-input trans"
    :class="sizeClass"
    tabindex="-1"
    @focusin="focus = true"
    @focusout="focus = false"
  >
    <legend>{{ label }}</legend>
    <div class="material-input-content left">
      <slot></slot>
    </div>
  </fieldset>
</template>

<script setup>
import { computed, ref } from "vue";

// Define Props
const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "small",
    validator: (value) =>
      ["mini", "small", "medium", "tininess", "default"].includes(value),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

// Reactive State
const focus = ref(false);

// Computed Class Binding
const sizeClass = computed(() => {
  return {
    "material-input-disabled": props.disabled,
    "material-input-focus": !props.disabled && focus.value,
    "material-input-mini": props.size === "mini",
    "material-input-small": props.size === "small",
    "material-input-medium": props.size === "medium",
    "material-input-medium": props.size === "default",
    "material-input-tininess": props.size === "tininess",
  };
});
</script>

<style lang="scss" scoped>
  @use "@/css/base.scss" as *;

  .material-input {
    outline: none;
    background-color: #fff;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding-inline-start: 12px;
    padding-inline-end: 12px;

    legend {
      color: #9d9d9d;
      line-height: normal;
      padding-inline-start: 10px;
      padding-inline-end: 10px;
    }

    .material-input-content {
      margin-bottom: 5px;
      position: relative;
    }
  }

  .material-input-focus {
    border: 1px solid $color-primary;

    legend {
      color: $color-primary;
    }
  }

  .material-input-disabled {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed;
  }

  .material-input-mini {
    .material-input-content {
      height: 28px;
      line-height: 28px;
    }
  }

  .material-input-small {
    .material-input-content {
      height: 32px;
      line-height: 32px;
    }
  }

  .material-input-medium {
    .material-input-content {
      height: 36px;
      line-height: 36px;
    }
  }

  .material-input-tininess {
    legend {
      font-size: 12px;
    }

    .material-input-content {
      margin-bottom: 3px;
      position: relative;
      margin-top: -1px;
    }
  }

  .is-error {
    legend {
      color: #F56C6C;
    }

    .material-input {
      border-color: #F56C6C;
    }
  }
  .material-input-content > .el-select {
  width: 100%;
}
</style>
